
const menuSource = `
판매 내역 조회
  신청내역                             | /front/via_order/via_apply
  입금내역                             | /front/via_order/via_income
  판매현황                             | /front/via_order/via_chart
증표 판매
  증표 판매                            | /front/via_order/order_form
  증표 구입 내역                       | /front/via_order/order_detail
  영수증 출력(기간별 내역 출력)        | /front/via_order/order_receipt
증표 사용/입력/조회
  증표 사용                            | /front/via_use/use_reg
  증표 사용 내역 조회/수정             | /front/via_use/use_edit
신고/신청
  면제증표 신청                        | /front/via_mgr/free_mgr
  미사용 증표 전환 신청                | /front/via_mgr/unuse_move
  미사용 증표 환불 신청                | /front/via_mgr/unuse_refund
  오사용 증표 정정 신청                | /front/via_mgr/via_info_edit
입출금관리
  환불관리                             | /front/bank/via_refund
  가상계좌관리                         | /front/bank/va_account
수임사건 내역 조회
  수임사건 건수 조회                   | /front/via_find/via_suim
  수임사건 상세 조회                   | /front/via_find/via_suim_detail
각종 조회
  사임취하처리 조회                    | /front/via_report/via_saim
  경유건수 현황자료                    | /front/via_report/report3
  귀속수임사건 보고기간 설정           | /front/via_report/report4
  회원별 귀속수임사건 신고서 조회      | /front/via_report/report5
  귀속수임사건 신고서 제출여부 조회    | /front/via_report/report7
  특정변호사(경유건수 현황)            | /front/via_report/report6
  공직퇴임변호사내역                   | /front/via_report/report8
기타
  징계정보                             | /front/etc/push_info
  증표정보                             | /front/etc/via_info
  내역마감처리                         | /front/etc/close_mgr
  과세자료 제출현황                    | /front/etc/report3010
  공지사항                             | /front/etc/notice
  질의응답                             | /front/etc/qna
  사용자관리                           | /front/etc/user
  법인회원관리                         | /front/etc/user_office
사이트 관리
  경유증표 종류		                     | /front/site/via_kind
  관련 규정 			                     | /front/site/via_law
  자주묻는질문(FAQ)                    | /front/site/via_faq
  각 메뉴별 수정	                     | /front/site/via_menu
  코드 관리	                           | /front/site/via_code
SAMPLE
  회원선택                             | /front/sample/회원선택
  공통코드                             | /front/sample/공통코드
  날짜선택                             | /front/sample/날짜선택
  레포트                               | /front/sample/레포트
  파일첨부                             | /front/sample/파일첨부
  TABS                                 | /front/sample/tabs
  SAMPLE                               | /front/sample/sample1
  SAMPLE2                              | /front/sample/sample2
  3depth test
    테스트1
    테스트2

`

/*
  저 문자열을 아래와 같이 변환해 준다.

  {
    name: '판매 내역 조회',
    children: [
      { name: '신청내역' },
      { name: '입금내역' },
      { name: '판매내역' },
    ]
  },
  {
    name: '증표 판매',
    children: [
      { name: '증표 판매' },
      { name: '증표 구입 내역' },
      { name: '영수증 출력' },
    ]
  },

*/


let menuList = []
let menuMap = {}

function doit() {
  // console.log("xxxxxxxxxx", this.menuSource.split("\n"));
  let m = [];
  let pushedItems = [] // 기존 아이템 저장 push / pop
  let currentItem = {}; // 현재 아이템
  let prevItem = {}; // 현재 아이템
  let id = 0;
  let prevSpSize = 2;
  for(let item of menuSource.split("\n")) {
    if (!item.trim()) continue // 빈값은 pass

    let newItem = {id : ++id}
    const itemRegex = /^\s*(.*)\s*\|\s*(.*)$/g;
    if (itemRegex.test(item)) { // 링크가 있는 메뉴인 경우
        newItem.name = RegExp.$1.trim()
        newItem.link = RegExp.$2.trim()
        newItem.parentName = currentItem.name
        menuMap[newItem.link] = newItem
    } else {
        newItem.name = item.trim();
    }
    if (/^(\s+)/.test(item)) { // sub
      // console.log("len", item, RegExp.$1.length)
      const spSize = RegExp.$1.length // 공백 사이즈
      if (spSize == prevSpSize) {
        currentItem.children || ( currentItem.children = [] ) // children 가 null 이면 빈 배열 셋팅
        currentItem.children.push(prevItem = newItem)
      } else if (spSize > prevSpSize) {
        pushedItems.push(currentItem)
        currentItem = prevItem
        currentItem.children || ( currentItem.children = [] ) // children 가 null 이면 빈 배열 셋팅
        currentItem.children.push(newItem)
      } else if (spSize < prevSpSize) {
        currentItem = pushedItems.pop();
        currentItem.children || ( currentItem.children = [] ) // children 가 null 이면 빈 배열 셋팅
        currentItem.children.push(newItem)
      }
      prevSpSize = spSize;
      newItem.depth = pushedItems.length;

    } else { // 1 depth
      newItem.depth = 0
      m.push(currentItem = newItem)
      pushedItems = [newItem]
      prevSpSize = 2;
    }
  }
  // console.log("m = ", m)
  menuList = m
}

doit()

export {
  menuList,
  menuMap
}
